const MAX_FILE_SIZE = 10 * 1024 * 1024 // 10 MB

export const checkFileSize = (file: File) => {
  return file.size <= MAX_FILE_SIZE
}
